import { createFileRoute } from '@tanstack/react-router';

import { MicrosoftCallbackPage } from '@/features/login/ui';

export const Route = createFileRoute('/login/microsoft')({
  component: MicrosoftCallbackPage,
});
